import { Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AppState } from '../../app.state';
import { Store } from '@ngrx/store';
import { Consent } from '../../modules/consent/model/consent.model';
import { selectConsent } from '../../modules/consent/consent.selector';
import { ModuleRoutingConstants } from '../../core/helpers/module-routing.constants';

@Component({
    selector: 'ssf-app-navigation',
    template: require('./app-navigation.component.html'),
    styles: [require('./app-navigation.component.scss')]
})
export class AppNavigationComponent {

    /**
     * To be available in HTML template.
     */
    public ModuleRoutingConstants = ModuleRoutingConstants;

    public i18n = 'APP.NAVIGATION.';
    public showContracts$: Observable<boolean>;
    public consent$: Observable<Consent>;

    constructor(private store: Store<AppState>) {

        this.consent$ = this.store.select(selectConsent);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/components/app-navigation/app-navigation.component.ts